module.exports = __webpack_public_path__ + "img/l-hd.bf40b50f.jpg";